function setCookie(name, value, props) {
  if (typeof document === "undefined") {
    return;
  }
  props = props || {};

  const exp = props.expires;

  if (typeof exp === "number" && exp) {
    props.expires = new Date(Date.now() + exp * 864e5).toUTCString();
  }

  if (exp && exp.toUTCString) {
    props.expires = exp.toUTCString();
  }

  value = encodeURIComponent(value);

  name = encodeURIComponent(name).replace(
    /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
    decodeURIComponent
  );

  let updatedCookie = `${name}=${value}`;

  const propsKeys = Object.keys(props);

  for (let i = 0; i < propsKeys.length; i++) {
    const propName = propsKeys[i];
    updatedCookie += `; ${propName}`;
    const propValue = props[propName];

    if (propValue !== true) {
      updatedCookie += `=${propValue}`;
    }
  }

  document.cookie = updatedCookie;
}

export default setCookie;
